import { Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material";
import { Editor } from "@tiptap/core";
import { BubbleCommandItem, bubbleCommandList } from "./slashMenuList";

import { Popover } from "components/popover";

export const BubbleMenuList = ({ editor }: { editor: Editor }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      sx={{
        p: "8px",
        border: `1px solid ${theme.palette.neutral["020"]}`,
        borderRadius: "8px",
        boxShadow: "0px 0px 4px 0px #0000000F,0px 0px 2px 0px #0000000A",
        gap: "4px",
        bgcolor: "#FFF",
      }}
      divider={<Divider orientation="vertical" flexItem />}
    >
      {bubbleCommandList.map((parentItem, parentIndex) => (
        <>
          {parentItem.items.map((item, index) => {
            if (item.hasDropdown) {
              return (
                <Popover
                  key={index}
                  paperSx={{
                    mt: "20px",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  popoverContent={(closePopover) =>
                    typeof item.dropdownComponent === "function"
                      ? item.dropdownComponent(editor, closePopover)
                      : item.dropdownComponent
                  }
                >
                  <BubbleIcon
                    item={item}
                    editor={editor}
                    key={`${index}_${item.title}`}
                  />
                </Popover>
              );
            }
            return (
              <BubbleIcon
                item={item}
                editor={editor}
                key={`${index}_${item.title}`}
              />
            );
          })}
        </>
      ))}
    </Stack>
  );
};

const BubbleIcon = ({
  item,
  editor,
}: {
  item: BubbleCommandItem;
  editor: Editor;
}) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      sx={{
        cursor: "pointer",
        minWidth: "32px",
        minHeight: "32px",
        borderRadius: "6px",
        padding: "4px",
        outline: "none",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        backgroundColor: item.isActive({ editor: editor })
          ? theme.palette.neutral["005"]
          : "transparent",

        "&:hover": {
          backgroundColor: theme.palette.neutral["010"],
        },
      }}
      onClick={(e) => {
        e.preventDefault();
        if (!item.hasDropdown) {
          item.command({ editor: editor });
        }
      }}
      component="button"
    >
      {typeof item.icon === "function" ? item.icon(editor) : item.icon}
    </Stack>
  );
};
